import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './Logo.module.css';
import Badge from '../../../Badge';
import Stack from '../../../Stack';

const bindClasses = classNameBind.bind(styles);

export default class Logo extends React.PureComponent {
  image = React.createRef();

  static defaultProps = {
    logoSrc: '/statics/logo?v2',
    isBeta: false,
    isNew: false,
  }

  handleLogoLoaded = () => {
    this.image.current.style.display = 'inline-block';
  }

  render() {
    const {
      logoSrc,
      logoLabel,
      isBeta,
      isNew,
      t,
    } = this.props;

    return (
      <div
        className={bindClasses('wrapper')}
        data-ppuc-id="ProductBar.Logo"
      >
        <div>
          <img
            ref={this.image}
            src={logoSrc}
            onLoad={this.handleLogoLoaded}
            alt="Logo"
          />
        </div>
        <div className={bindClasses('label')}>
          <Stack spacing="narrow" verticalAlign="center">
            <Stack.Item>
              {logoLabel}
            </Stack.Item>
            {isBeta ? <Stack.Item><Badge size="small" text={t('actionlist.badge.beta.label').toUpperCase()} color="blue" /></Stack.Item> : null}
            {isNew ? <Stack.Item><Badge size="small" color="blue" text={t('actionlist.badge.new.label').toUpperCase()} /></Stack.Item> : null}
          </Stack>
        </div>
      </div>
    );
  }
}
